import React, { useState } from 'react'
import { firestore } from '../../firebase';

function AddRegion() {

    const [region, setRegion] = useState("");
    const [pris, setPris] = useState(30000);

    const [message, setMessage] = useState("");
    const [error, setError] = useState("");

    async function submitHandler(e) {
        e.preventDefault();
        try {
            const regionRef = firestore.collection("bolig-regioner");
            const data = {
                region,
                kvm_pris: +pris
            }
            regionRef.add(data);
            setMessage("Lagt til!")
        } catch (error) {
            setError("Kunne ikke legge til");
        }
    }

    return (
        <form onSubmit={submitHandler}>

            <label>Region</label>
            <input className="form-control mb-2" placeholder="Region" value={region} onChange={e => setRegion(e.target.value)} />

            <label>Kvadratmeterpris {pris} kr</label>
            <input className="form-control mb-2" type="range" step="1000" max="200000" value={pris} onChange={e => setPris(e.target.value)} />

            {message && <div className="alert alert-success">{message}</div>}
            {error && <div className="alert alert-danger">{error}</div>}
            <button className="btn btn-success btn-block">Legg til region</button>
        </form>
    )

}
export default AddRegion;